import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Language } from "@common/models";
import { environment } from "environments/environment";

@Injectable({providedIn: 'root'})
export class LanguageService{


    /**
     * Constructor for the service
     * @param _http client
     */
    constructor(private _http: HttpClient){};


    /**
     * Search language 
     * @returns Array of Language
     */
    getAll(){
        return this._http.get<Language[]>(`${environment.commonApiUrl}/api/language`);
    }

}
